import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function ContactHero() {
  const { t } = useTranslation();
  return (
    <section className="relative w-full min-h-[420px] md:min-h-[520px] flex items-center justify-center overflow-hidden pt-20">
      <img
        src="https://readdy.ai/api/search-image?query=Serene%20Vietnamese%20landscape%20with%20a%20traditional%20wooden%20boat%20on%20calm%20turquoise%20water%20at%20sunrise%2C%20soft%20golden%20light%2C%20misty%20limestone%20mountains%20in%20the%20distance%2C%20peaceful%20tranquil%20atmosphere%2C%20cinematic%20travel%20photography%2C%20warm%20inviting%20tones&width=1800&height=900&seq=contact-hero-bg&orientation=landscape"
        alt={t('contact.heroAlt')}
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60" />

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12 text-center">
        <p className="text-accent-400 text-sm md:text-base tracking-wide uppercase mb-3">
          {t('contact.eyebrow')}
        </p>
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-4">
          {t('contact.title')}
        </h1>
        <p className="text-white/80 text-sm md:text-base max-w-xl mx-auto leading-relaxed">
          {t('contact.subtitle')}
        </p>

        <nav className="mt-8 flex items-center justify-center gap-2 text-sm text-white/70">
          <Link to="/" className="hover:text-white transition-colors">{t('contact.home')}</Link>
          <span>/</span>
          <span className="text-white">{t('contact.contact')}</span>
        </nav>
      </div>
    </section>
  );
}